import { SortDirection } from "@episerver/ui-framework";
import { Property } from "../../../businessFoundation/MetaClassData/MetaClassDataList/MetaClassDataModel";
import { Address } from "../../AddressManager/model/address";
import { Contact } from "../../ContactManager/model/contact";

export interface Organization {
    primaryKeyId: string | null;
    name: string;
    description: string;
    organizationTypeId: string | null;
    organizationType: string;
    organizationCustomerGroupId: string | null;
    organizationCustomerGroup: string;
    businessCategoryId: string | null;
    businessCategory: string;
    parentId: string | null;
    extendedProperties: Property[];
    children: Organization[];
    addresses: Address[];
    contacts: Contact[];
}

export interface OrganizationSearchResult {
    organizations: Organization[];
    totalCount: number;
}

export interface SearchParams {
    query: string;
    sortField: string;
    sortType: ServerSortType;
    startIndex: number;
    recordsToRetrieve: number;
    excludedOrgId?: string;
}

export interface DeleteParams {
    organizationIds: string[];
    mode: DeleteMode;
    query: string;
    sortField: string;
    sortType: ServerSortType;
    startIndex: number;
    recordsToRetrieve: number;
}

export interface SortModel {
    sortedColumn: string;
    sortDirection: SortDirection;
}

export interface PaginationModel {
    startRow: number;
    totalRowCount: number;
    rowsPerPage: number;
    rowsPerPageOptions: number[];
}

export interface AddContactsParams {
    contactIds: string[];
    organizationId: string;
}

export interface ConfirmDialog {
    open: boolean;
    data: {
        mode: number;
        organizationIds: string[];
    };
}

export interface AddChildOrganizationsParams {
    parentOrganizationId: string;
    organizationIds: string[];
}

export enum ServerSortType {
    Asc,
    Desc,
}

export enum OrganizationType {
    Organization = 1,
    OrganizationUnit = 2,
}

export enum DeleteMode {
    None,
    Detach,
    Delete,
}

export enum OrganizationTab {
    Details,
    Contacts,
    Organizations,
    Addresses,
}
